import React from 'react'
import Videos from '../../components/videos/Videos'
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import SwipeIcon from '@mui/icons-material/Swipe';
import './youtube.css'
import { youtubeData } from '../../data/youtubeData'

const Youtube = () => {
    const { header, scrollHint, videos } = youtubeData;
  return (
    <div className="youtube-section">
      <div className="youtube-container">
        <div className="youtube-header">
          <div className="youtube-badge">
            <PlayCircleOutlineIcon className="badge-icon" />
            <span>{header.badge.text}</span>
          </div>
          <h1 className="youtube-title">{header.title}</h1>
          <p className="youtube-description">
            {header.description}
          </p>
        </div>

        {/* Scroll Hint */}
        <div className="youtube-scroll-hint">
          <SwipeIcon className="scroll-hint-icon" />
          <span>{scrollHint.text}</span>
        </div>

        <Videos>
          {videos.map((video, index) => (
            <span key={index}>
              <div className="video-card">
                <div className="video-thumbnail">
                  <iframe 
                    className="video-iframe"
                    title={`YouTube Video ${video.title}`}
                    src={`https://www.youtube.com/embed/${video.id}?enablejsapi=1&rel=0&modestbranding=1`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
                
                <div className="video-content">
                  <h3 className="video-title">{video.title}</h3>
                  <p className="video-description">{video.description}</p>
                  
                  <div className="video-meta">
                    <div className="video-duration">
                      <PlayCircleOutlineIcon className="meta-icon" />
                      <span>{video.duration}</span>
                    </div>
                    <div className="video-views">
                      <span>{video.views}</span>
                    </div>
                  </div>
                </div>
              </div>
            </span>
          ))}
        </Videos>
      </div>
    </div>
  )
}

export default Youtube
